import(/* webpackMode: "eager" */ "/app/src/app/(ru)/(help-pages)/consent/page.tsx");
